import { render } from "./Wallet.vue?vue&type=template&id=133320cb&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=133320cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133320cb"]])

export default __exports__